import { ServiceFunction } from "utils/index";
import BaseService from "../base";
import {
  AccountAbbrListResponse,
  IProcessDetailResponse,
  MyRequestListPayload,
  MyRequestListResponse,
  MyRequestTableFilterResponse,
  MyRequestTopFilterResponse,
} from "./types";

class MyRequestListService extends BaseService {
  getAccountAbbrList = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getToDoListAccountAbbreviations", {}, success, error, returnPara);
  };

  // @ts-ignore
  getAccountAbbrListNew = (): Promise<AccountAbbrListResponse> =>
    this.sendSyncRequest("getToDoListAccountAbbreviations", {});

  getAllAccountAbbreviations = (para: any, success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getAllAccountAbbreviations", para, success, error, returnPara);
  };

  // @ts-ignore
  getAllAccountAbbreviationsNew = (para: any): Promise<AccountAbbrListResponse> =>
    this.sendSyncRequest("getAllAccountAbbreviations", para);

  getProcessCategoryDDL = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getProcessCategoryDDL", {}, success, error, returnPara);
  };

  // @ts-ignore
  getProcessCategoryDDLNew = (): Promise<{ id: string; name: string }[]> =>
    this.sendSyncRequest("getProcessCategoryDDL", {});

  getMyRequestTopFilter = (success: any, error: any, returnPara: any) => {
    // @ts-ignore
    this.sendRequest("getMyRequestTopFilter", {}, success, error, returnPara);
  };

  // @ts-ignore
  getMyRequestTopFilterNew = (): Promise<MyRequestTopFilterResponse> =>
    this.sendSyncRequest("getMyRequestTopFilter", {});

  // @ts-ignore
  getMyRequestListNew = (payload: MyRequestListPayload): Promise<MyRequestListResponse> =>
    this.sendSyncRequest("getMyRequestListNew", payload);

  // @ts-ignore
  getMyRequestFilterNew = (
    para: Omit<MyRequestListPayload, "pageIndex" | "pageSize">
  ): Promise<MyRequestTableFilterResponse> => this.sendSyncRequest("getMyRequestFilterNew", para);

  getProcessDetailData: ServiceFunction<{ processID: string }, IProcessDetailResponse> = (
    para,
    success,
    error
  ) => {
    // @ts-ignore
    this.sendRequest("getProcessDetailData", para, success, error);
  };

  // @ts-ignore
  getMyRequestExportFile = (payload: MyRequestListPayload) =>
    this.sendSyncRequest("getMyRequestExportFile", payload) as Promise<string>;
}

const myRequestListService = new MyRequestListService();

export default myRequestListService;
